export default __webpack_public_path__ + "static/media/Merc.0a31177f.jpg";